module.exports = __webpack_public_path__ + "media/fonts/Oricons-d37de326601604f4b1892f4d26dbd22c.eot";